import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HeaderArea, HeaderTitle } from 'src/components';
import { Tabs } from '.';
import type { OrgTabOptionsValue } from 'src/types';

type Props = {
  currentTab: OrgTabOptionsValue;
  setCurrentTab: (tab: OrgTabOptionsValue) => void;
};

export const Header = ({ currentTab, setCurrentTab }: Props) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const handleTabChange = (tab: OrgTabOptionsValue) => {
    // update the url without reloading the page, allows user to go back to the same tab
    window.history.pushState({}, '', `${window.location.pathname}?tab=${tab}`);
    setCurrentTab(tab);
  };

  // update the current tab if the url has a tab param
  useEffect(() => {
    const tab = searchParams.get('tab');
    if (tab) {
      setCurrentTab(tab as OrgTabOptionsValue);
    }
  }, [searchParams, setCurrentTab]);

  return (
    <HeaderArea>
      <HeaderTitle title={t('common.organization_settings')} />
      <Tabs currentTab={currentTab} handleTabChange={handleTabChange} />
    </HeaderArea>
  );
};
